export default {
    items: [
        {
            name: "Dashboard",
            url: "/dashboard",
            icon: "fa fa-dashboard",
            permission: null
        },
        {
            name: "Tableau",
            url: "/tableau",
            icon: "fa fa-pie-chart",
            permission: 1400
        },
        {
            name: "Master Data",
            url: "/master",
            icon: "fa fa-wrench",
            children: [
                {
                    name: "Aksesoris",
                    url: "/master/aksesoris",
                    icon: "fa fa-minus",
                    permission: 100
                },
                {
                    name: "Barang",
                    url: "/master/barang",
                    icon: "fa fa-minus",
                    permission: 101
                },
                {
                    name: "Rumus Umum Grade",
                    url: "/master/rumus-umum-grade",
                    icon: "fa fa-minus",
                    permission: 102
                },
                {
                    name: "Adj. Harga Gudang",
                    url: "/master/adjustment-harga-gudang",
                    icon: "fa fa-minus",
                    permission: 103
                },
                {
                    name: "Adj. Harga Batangan",
                    url: "/master/adjustment-harga-batangan",
                    icon: "fa fa-minus",
                    permission: 108
                },
                {
                    name: "Kategori Kerusakan",
                    url: "/master/kategori-kerusakan",
                    icon: "fa fa-minus",
                    permission: 104
                },
                {
                    name: "Adj. Kerusakan",
                    url: "/master/adjustment-kerusakan",
                    icon: "fa fa-minus",
                    permission: 105
                },
                {
                    name: "Spek Barang",
                    url: "/master/spek",
                    icon: "fa fa-minus",
                    permission: 106
                },
                {
                    name: "Warna Barang",
                    url: "/master/warna",
                    icon: "fa fa-minus",
                    permission: 107
                },
                {
                    name: "Kategori Foto",
                    url: "/master/kategori-foto",
                    icon: "fa fa-minus",
                    permission: 107
                }
            ]
        },
        {
            name: "Penjualan",
            url: "/sales",
            icon: "fa fa-dollar",
            children: [
                {
                    name: "Customer",
                    url: "/sales/customer",
                    icon: "fa fa-minus",
                    permission: 200
                },
                {
                    name: "Invoice",
                    url: "/sales/invoice",
                    icon: "fa fa-minus",
                    permission: 201
                },
                {
                    name: "Transaksi",
                    url: "/sales/transactions",
                    icon: "fa fa-minus",
                    permission: 202
                },
                {
                    name: "Daftar Retur",
                    url: "/sales/retur",
                    icon: "fa fa-minus",
                    permission: 203
                },
                {
                    name: "Daftar Request Retur",
                    url: "/sales/retur-request",
                    icon: "fa fa-minus",
                    permission: 204
                },
                {
                    name: "Transaksi Poin",
                    url: "/sales/point-transactions",
                    icon: "fa fa-minus",
                    permission: 205
                }
            ]
        },
        {
            name: "Inventory",
            url: "/inventory",
            icon: "fa fa-cubes",
            permission: 300
        },
        {
            name: "Pindah Gudang",
            url: "/pindah-gudang",
            icon: "fa fa-archive",
            permission: 400
        },
        {
            name: "Adjustment Barcode",
            url: "/adjustment-barcode",
            icon: "fa fa-ticket",
            permission: 500
        },
        {
            name: "Log Barcode",
            url: "/log-barcode",
            icon: "fa fa-book",
            permission: 600
        },
        {
            name: "Barang Masuk",
            url: "/barang-masuk",
            icon: "fa fa-truck",
            permission: 700,
            children: [
                {
                    name: "Approve Barang",
                    url: "/barang-masuk/approve",
                    icon: "fa fa-minus",
                    permission: 701
                },
                {
                    name: "Upload Foto / Video",
                    url: "/barang-masuk/upload",
                    icon: "fa fa-upload",
                    permission: 702
                },
                {
                    name: "Input Aksesoris",
                    url: "/barang-masuk/input-accesoris",
                    icon: "fa fa-headphones",
                    permission: 703
                }
            ]
        },
        {
            name: "Kirim Balik PGI",
            url: "/kirim-balik",
            icon: "fa fa-arrow-left",
            children: [
                {
                    name: "Return Item",
                    url: "/kirim-balik/item",
                    icon: "fa fa-minus",
                    permission: 800
                },
                {
                    name: "Invoice Pengembalian",
                    url: "/kirim-balik/invoice",
                    icon: "fa fa-minus",
                    permission: 801
                },
                {
                    name: "Batal Return Item",
                    url: "/kirim-balik/cancel-item",
                    icon: "fa fa-minus",
                    permission: 802
                },
                {
                    name: "Invoice Pembatalan",
                    url: "/kirim-balik/cancel-invoice",
                    icon: "fa fa-minus",
                    permission: 803
                }
            ]
        },
        {
            name: "Reset Inventory",
            url: "/inventory-reset",
            icon: "fa fa-refresh",
            permission: 900
        },
        {
            name: "Laporan",
            url: "/laporan",
            icon: "fa fa-book",
            permission: 1000
        },
        {
            name: "Stock Report",
            url: "/inventory-report",
            icon: "fa fa-cubes",
            permission: 1100
        },
        {
            name: "Shopping Cart",
            url: "/shopping-cart",
            icon: "fa fa-shopping-cart",
            permission: 1200
        },
        {
            name: "Administrasi",
            url: "/admin",
            icon: "fa fa-users",
            children: [
                {
                    name: "User",
                    url: "/admin/user",
                    icon: "fa fa-minus",
                    permission: 1300
                },
                {
                    name: "Role",
                    url: "/admin/role",
                    icon: "fa fa-minus",
                    permission: 1301
                },
                {
                    name: "Divisi",
                    url: "/admin/divisi",
                    icon: "fa fa-minus",
                    permission: 1302
                }
            ]
        }
    ]
};
